export default {
    ROLE_REMOVED_SUCCESSFULLY: "Роль успешно удалена",
    ROLES_REMOVED_SUCCESSFULLY: "Роли успешно удалены",
    ROLE_CREATED_SUCCESSFULLY: "Роль успешна создана",
    ROLE_EDITED_SUCCESSFULLY: "Роль успешно изменена"
};
